import { apiFetch } from '@/api/fetch';
import { UserContextSchema, type UserContext } from '@restaurant/api-contracts';
import type { ZodError } from 'zod';

export class UserContextShapeError extends Error {
  readonly issues: ZodError['issues'];

  constructor(issues: ZodError['issues']) {
    super('Unexpected /auth/me response shape');
    this.name = 'UserContextShapeError';
    this.issues = issues;
  }
}

export async function fetchUserContext(): Promise<UserContext> {
  const body = await apiFetch<unknown>('/auth/me');
  const parsed = UserContextSchema.safeParse(body);
  if (!parsed.success) {
    throw new UserContextShapeError(parsed.error.issues);
  }
  return parsed.data;
}
